import React from 'react'
import Button from '@material-ui/core/Button';
import './Puzz.css'
import { NavLink } from 'react-router-dom';
const Puz29 = () => {
    return (
        <div> 
            <NavLink to='/category/Puzzels/Puzzel30'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel28'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article
    class="container">
    <h1 class="title">Car Wheel Puzzle</h1>
   
    <div class="text">
        <p><strong><u>Puzzle</u>: </strong>A car has 4 tyres and 1 spare tyre. Each tyre can travel a maximum distance
            of 20000 miles before wearing off. What is the maximum distance the car can travel before you are forced to
            buy a new tyre? You are allowed to change tyres (using the spare tyre) an unlimited number of times.<br/></p>
        <p><br/><br/><br/><br/><br/><br/><br/><br/><strong><u>Answer</u>:</strong> 25000 kms</p>
        <div className='containers'>
        <p><strong><u>Solution</u>:</strong> Divide the lifetime of the spare tire into 4 equal part i.e., 5000 and swap
            it at each completion of 5000 miles distance.</p>

        <p>Let four tyres be named as A, B, C and D and spare tyre be S.</p>
        <ol>
            <li><strong>5000 KMs:</strong> Replace A with S. Remaining distances (A, B, C, D, S) : 15000, 15000, 15000,
                15000, 20000.<br/></li>
            <li><strong>10000 KMs:</strong> Put A back to its original position and replace B with S. Remaining
                distances (A, B, C, D, S) : 15000, 10000, 10000, 10000, 15000.<br/></li>
            <li><strong>15000 KMs:</strong> Put B back to its original position and replace C with S. Remaining
                distances (A, B, C, D, S) : 10000, 10000, 5000, 5000, 10000.<br/></li>
            <li><strong>20000 KMs:</strong> Put C back to its original position and replace D with S. Remaining
                distances (A, B, C, D, S) : 5000, 5000, 5000, 0, 5000.<br/></li>
            <li><strong>25000 KMs:</strong> Every tyre is now worn out completely.<br/></li>
        </ol>
        <p>All tyres are used to their full strength.</p><br/>
       
        </div>
       
        <h3 align="center"><strong>Related Amazon interview question</strong></h3>
        <p>There are n pencils, each having l length. Each can write 4 kilometres. After writing 4 kilometres it has l/4
            length. One can join 4 pencils which are having l/4 length and can make 1 pencil. One can’t make pencil of
            pieces if remaining pieces are 3 or 2 or 1 in number but one can include these remaining pieces whenever
            needed.<br/>Write a relation independent of l, length of the given pencil, for how much one can write from n
            pencils.</p>
        <p><strong>Examples:</strong></p>
        <pre><strong>Input:</strong> 4
    <strong>Output:</strong> 20
    </pre>
      
        <p><strong>Recursive Approach:</strong><br/>Suppose we use 3 pencils that will 12 and generate 3 used pencils,
            now if the remaining pencils are greater than zero at least 1 unused pencil can be used with those 3 unused
            to write 4 and that will generate 1 more unused pencil. This will keep repeating.</p>
        <pre>if(n-3 &gt;= 1)&#123;
      f(n) = f(n-3) + 12 + 4
    &#125; 
    else&#123;
      // Used pencil that cannot be used
      f(n) = 4 + 4 
    &#125;
    </pre>
        <p>Below is the implementation of the above approach:</p>

                  
                      
                                    <td class="code">
                                        <div class="output">
                                            <div class="line number1 index0 alt2"><code class="keywords">int</code>
                                                <code class="plain">count(</code><code class="keywords">int</code>
                                                <code class="plain">n)</code></div>
                                            <div class="line number2 index1 alt1"><code class="plain">&#123;</code></div>
                                            <div class="line number3 index2 alt2"><code
                                                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                                                    class="library">if</code> <code
                                                    class="plain">(n &lt; 4) &#123;</code></div>
                                            <div class="line number4 index3 alt1"><code
                                                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                                                    class="library">return</code> <code
                                                    class="plain">(n * 4);</code></div>
                                            <div class="line number5 index4 alt2"><code
                                                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                                                    class="plain">&#125;</code></div>
                                            <div class="line number6 index5 alt1"><code
                                                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                                                    class="library">else</code> <code class="plain">&#123;</code></div>
                                            <div class="line number7 index6 alt2"><code
                                                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                                                    class="library">return</code> <code
                                                    class="plain">(16 + count(n - 3));</code></div>
                                            <div class="line number8 index7 alt1"><code
                                                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                                                    class="plain">&#125;</code></div>
                                            <div class="line number9 index8 alt2"><code class="plain">&#125;</code></div>
                                        </div>
                                    </td>
                               
           
        
        <p><strong>Mathematical Approach O(1):</strong><br/>Above relation can be optimized in O(1)</p>
        <pre>// x is max no of time we can   <br />
    //subtract 3 without n-3 &lt;= 3  <br />
    n - 3 + x &lt;= 3       <br />
    x  &gt;  (n-3)/3  <br />
    i.e. <strong>n/3 - 1</strong> if it divides exactly <br />
    else <strong>n/3</strong> <br />
    </pre>
        <p>Below is the implementation of the above approach:<br/></p>
   </div>
   <div class="tabs">
    <input type="radio" name="tab" id="tab1" checked="checked"/>
    <label for="tab1">CPP</label>
    <input type="radio" name="tab" id="tab2"/>
    <label for="tab2">Java </label>
    <input type="radio" name="tab" id="tab3"/>
    <label for="tab3">Python</label>
    <input type="radio" name="tab" id="tab4"/>
    <label for="tab4">C#</label>
  
    <div class="tab-content-wrapper">
      <div id="tab-content-1" class="tab-content">
        <div class="container">
            <div class="line number1 index0 alt2"><code
                    class="comment">// C++ program to find relation independent of l</code>
            </div>
            <div class="line number2 index1 alt1"><code
                    class="comment">// length of the given pencil, for how much one</code>
            </div>
            <div class="line number3 index2 alt2"><code
                    class="comment">// can write from n pencils.</code></div>
            <div class="line number4 index3 alt1"><code
                    class="undefined spaces">&nbsp;</code>&nbsp;</div>
            <div class="line number5 index4 alt2"><code
                    class="library">#include &lt;bits/stdc++.h&gt;</code>
            </div>
            <div class="line number6 index5 alt1"><code
                    class="library">using</code> <code
                    class="library">namespace</code> <code
                    class="plain">std;</code></div>
            <div class="line number7 index6 alt2"><code
                    class="undefined spaces">&nbsp;</code>&nbsp;</div>
            <div class="line number8 index7 alt1"><code
                    class="comment">// Function to find no of pencils</code>
            </div>
            <div class="line number9 index8 alt2"><code
                    class="keywords">int</code> <code
                    class="plain">count(</code><code
                    class="keywords">int</code> <code class="plain">n)</code>
            </div>
            <div class="line number10 index9 alt1"><code class="plain">&#123;</code>
            </div>
            <div class="line number11 index10 alt2"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="keywords">int</code> <code
                    class="plain">x = (n / 3) - 1;</code></div>
            <div class="line number12 index11 alt1"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="library">if</code> <code
                    class="plain">(n % 3) &#123;</code></div>
            <div class="line number13 index12 alt2"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="plain">x++;</code></div>
            <div class="line number14 index13 alt1"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="plain">&#125;</code></div>
            <div class="line number15 index14 alt2"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="library">return</code> <code
                    class="plain">(4 * x + 4 * n);</code></div>
            <div class="line number16 index15 alt1"><code class="plain">&#125;</code>
            </div>
            <div class="line number17 index16 alt2"><code
                    class="undefined spaces">&nbsp;</code>&nbsp;</div>
            <div class="line number18 index17 alt1"><code
                    class="comment">// Driver function</code></div>
            <div class="line number19 index18 alt2"><code
                    class="keywords">int</code> <code
                    class="plain">main()</code></div>
            <div class="line number20 index19 alt1"><code class="plain">&#123;</code>
            </div>
            <div class="line number21 index20 alt2"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="keywords">int</code> <code
                    class="plain">n = 5;</code></div>
            <div class="line number22 index21 alt1"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="plain">cout &lt;&lt; count(n) &lt;&lt; endl;</code>
            </div>
            <div class="line number23 index22 alt2"><code class="plain">&#125;</code>
            </div>
        </div>
        </div>
      <div id="tab-content-2" class="tab-content">
        
        <div class="container">
            <div class="line number1 index0 alt2"><code
                    class="comment">// Java program to find relation independent of l</code>
            </div>
            <div class="line number2 index1 alt1"><code
                    class="comment">// length of the given pencil, for how much one</code>
            </div>
            <div class="line number3 index2 alt2"><code
                    class="comment">// can write from n pencils.</code></div>
            <div class="line number4 index3 alt1"><code
                    class="keyword">class</code> <code class="plain">NooB</code>
            </div>
            <div class="line number5 index4 alt2"><code class="plain">&#123;</code>
            </div>
            <div class="line number6 index5 alt1"><code
                    class="undefined spaces">&nbsp;</code>&nbsp;</div>
            <div class="line number7 index6 alt2"><code
                    class="comment">// Function to find no of pencils</code>
            </div>
            <div class="line number8 index7 alt1"><code
                    class="keyword">static</code> <code
                    class="keyword">int</code> <code
                    class="plain">count(</code><code class="keyword">int</code>
                <code class="plain">n)</code></div>
            <div class="line number9 index8 alt2"><code class="plain">&#123;</code>
            </div>
            <div class="line number10 index9 alt1"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="keyword">int</code> <code
                    class="plain">x = (n / </code><code
                    class="value">3</code><code class="plain">) - </code><code
                    class="value">1</code><code class="plain">;</code></div>
            <div class="line number11 index10 alt2"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="keyword">if</code> <code
                    class="plain">(n % </code><code class="value">3</code> <code
                    class="plain">&gt; </code><code class="value">0</code><code
                    class="plain">)&nbsp;</code></div>
            <div class="line number12 index11 alt1"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="plain">&#123;</code></div>
            <div class="line number13 index12 alt2"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="plain">x++;</code></div>
            <div class="line number14 index13 alt1"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="plain">&#125;</code></div>
            <div class="line number15 index14 alt2"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="keyword">return</code> <code
                    class="plain">(</code><code class="value">4</code> <code
                    class="plain">* x + </code><code class="value">4</code>
                <code class="plain">* n);</code></div>
            <div class="line number16 index15 alt1"><code class="plain">&#125;</code>
            </div>
            <div class="line number17 index16 alt2"><code
                    class="undefined spaces">&nbsp;</code>&nbsp;</div>
            <div class="line number18 index17 alt1"><code
                    class="comment">// Driver code</code></div>
            <div class="line number19 index18 alt2"><code
                    class="keyword">public</code> <code
                    class="keyword">static</code> <code
                    class="keyword">void</code> <code
                    class="plain">main(String[] args)</code></div>
            <div class="line number20 index19 alt1"><code class="plain">&#123;</code>
            </div>
            <div class="line number21 index20 alt2"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="keyword">int</code> <code
                    class="plain">n = </code><code class="value">5</code><code
                    class="plain">;</code></div>
            <div class="line number22 index21 alt1"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="plain">System.out.print(count(n) +</code><code
                    class="string">"\n"</code><code class="plain">);</code>
            </div>
            <div class="line number23 index22 alt2"><code class="plain">&#125;</code>
            </div>
            <div class="line number24 index23 alt1"><code class="plain">&#125;</code>
            </div>
            <div class="line number25 index24 alt2"><code
                    class="undefined spaces">&nbsp;</code>&nbsp;</div>
           
        </div> </div>
      <div id="tab-content-3" class="tab-content">
        
        <div class="container">
            <div class="line number1 index0 alt2"><code
                    class="comment"># Python3 program to find relation independent of l</code>
            </div>
            <div class="line number2 index1 alt1"><code
                    class="comment"># length of the given pencil, for how much one</code>
            </div>
            <div class="line number3 index2 alt2"><code
                    class="comment"># can write from n pencils.</code></div>
            <div class="line number4 index3 alt1"><code
                    class="undefined spaces">&nbsp;</code>&nbsp;</div>
            <div class="line number5 index4 alt2"><code
                    class="comment"># Function to find no of pencils</code>
            </div>
            <div class="line number6 index5 alt1"><code
                    class="keyword">def</code> <code
                    class="plain">count(n):</code></div>
            <div class="line number7 index6 alt2"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="plain">x </code><code class="keyword">=</code> <code
                    class="plain">(n </code><code class="keyword">/</code><code
                    class="keyword">/</code> <code class="value">3</code><code
                    class="plain">) </code><code class="keyword">-</code> <code
                    class="value">1</code><code class="plain">;</code></div>
            <div class="line number8 index7 alt1"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="keyword">if</code> <code
                    class="plain">(n </code><code class="keyword">%</code> <code
                    class="value">3</code> <code class="plain">&gt; </code><code
                    class="value">0</code><code class="plain">):</code></div>
            <div class="line number9 index8 alt2"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="plain">x</code><code class="keyword">+</code><code
                    class="keyword">=</code><code class="value">1</code><code
                    class="plain">;</code></div>
            <div class="line number10 index9 alt1"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
            </div>
            <div class="line number11 index10 alt2"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="keyword">return</code> <code
                    class="plain">(</code><code class="value">4</code> <code
                    class="keyword">*</code> <code class="plain">x </code><code
                    class="keyword">+</code> <code class="value">4</code> <code
                    class="keyword">*</code> <code class="plain">n);</code>
            </div>
            <div class="line number12 index11 alt1"><code
                    class="undefined spaces">&nbsp;</code>&nbsp;</div>
            <div class="line number13 index12 alt2"><code
                    class="comment"># Driver code</code></div>
            <div class="line number14 index13 alt1"><code
                    class="keyword">if</code> <code
                    class="plain">__name__ </code><code
                    class="keyword">=</code><code class="keyword">=</code> <code
                    class="string">'__main__'</code><code class="plain">:</code>
            </div>
            <div class="line number15 index14 alt2"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="plain">n </code><code class="keyword">=</code> <code
                    class="value">5</code><code class="plain">;</code></div>
            <div class="line number16 index15 alt1"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="functions">print</code><code
                    class="plain">(count(n));</code></div>
            <div class="line number17 index16 alt2"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
            </div>
           
        </div> 
    </div>
      <div id="tab-content-4" class="tab-content">
        
        <div class="container">
            <div class="line number1 index0 alt2"><code
                    class="comment">// C# program to find relation independent of l</code>
            </div>
            <div class="line number2 index1 alt1"><code
                    class="comment">// length of the given pencil, for how much one</code>
            </div>
            <div class="line number3 index2 alt2"><code
                    class="comment">// can write from n pencils.</code></div>
            <div class="line number4 index3 alt1"><code
                    class="keyword">using</code> <code
                    class="plain">System;</code></div>
            <div class="line number5 index4 alt2"><code
                    class="undefined spaces">&nbsp;</code>&nbsp;</div>
            <div class="line number6 index5 alt1"><code
                    class="keyword">class</code> <code class="plain">NooB</code>
            </div>
            <div class="line number7 index6 alt2"><code class="plain">&#123;</code>
            </div>
            <div class="line number8 index7 alt1"><code
                    class="undefined spaces">&nbsp;</code>&nbsp;</div>
            <div class="line number9 index8 alt2"><code
                    class="comment">// Function to find no of pencils</code>
            </div>
            <div class="line number10 index9 alt1"><code
                    class="keyword">static</code> <code
                    class="keyword">int</code> <code
                    class="plain">count(</code><code class="keyword">int</code>
                <code class="plain">n)</code></div>
            <div class="line number11 index10 alt2"><code class="plain">&#123;</code>
            </div>
            <div class="line number12 index11 alt1"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="keyword">int</code> <code
                    class="plain">x = (n / 3) - 1;</code></div>
            <div class="line number13 index12 alt2"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="keyword">if</code> <code
                    class="plain">(n % 3 &gt; 0)&nbsp;</code></div>
            <div class="line number14 index13 alt1"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="plain">&#123;</code></div>
            <div class="line number15 index14 alt2"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="plain">x++;</code></div>
            <div class="line number16 index15 alt1"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="plain">&#125;</code></div>
            <div class="line number17 index16 alt2"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="keyword">return</code> <code
                    class="plain">(4 * x + 4 * n);</code></div>
            <div class="line number18 index17 alt1"><code class="plain">&#125;</code>
            </div>
            <div class="line number19 index18 alt2"><code
                    class="undefined spaces">&nbsp;</code>&nbsp;</div>
            <div class="line number20 index19 alt1"><code
                    class="comment">// Driver code</code></div>
            <div class="line number21 index20 alt2"><code
                    class="keyword">public</code> <code
                    class="keyword">static</code> <code
                    class="keyword">void</code> <code
                    class="plain">Main(String[] args)</code></div>
            <div class="line number22 index21 alt1"><code class="plain">&#123;</code>
            </div>
            <div class="line number23 index22 alt2"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="keyword">int</code> <code class="plain">n = 5;</code>
            </div>
            <div class="line number24 index23 alt1"><code
                    class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="plain">Console.Write(count(n) +</code><code
                    class="string">"\n"</code><code class="plain">);</code>
            </div>
            <div class="line number25 index24 alt2"><code class="plain">&#125;</code>
            </div>
            <div class="line number26 index25 alt1"><code class="plain">&#125;</code>
            </div>
            <div class="line number27 index26 alt2"><code
                    class="undefined spaces">&nbsp;</code>&nbsp;</div>
           
        </div> </div>
    </div>
  </div>
                 
              
            
       
        <div class="output"><b>Output:</b>
            <pre>24
    </pre>
        </div>
        
   
</article>
        </div>
    )
}

export default Puz29
